import React from "react";
import { IDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/IDataDefinition";
import { ObserveState } from "../../../CommonUI/StateManagement/ObserveState";
import { StateManager } from "../../../rule-engine-core/Common/StateManager";

import { DataDefinition } from "../../../rule-engine-core/Common/Data/DataDefinition";
import { VariablePickerDialog } from "../../../CommonUI/VariablePicker/VariablePickerDialog";

import { RuleTableColumn } from "../../../rule-engine-core/Rule/Table/Rule/Structure/RuleTableRuleColumn";

interface ColumnVariablePickerProps {
    rule: RuleTableColumn;
    editContext: {
        selectedColumnHeader: RuleTableColumn | undefined;
    };
    dataDefinition: DataDefinition;
    allowNew: boolean;
    onSet: (rule: RuleTableColumn, path: string) => void;
}

export const ColumnVariablePicker = (props: ColumnVariablePickerProps) => {
    const { rule, editContext, dataDefinition, allowNew } = props;

    const onCloseDialog = () => {
        editContext.selectedColumnHeader = undefined;
    };

    return (
        <ObserveState
            listenTo={editContext}
            properties={["selectedColumnHeader"]}
            control={() => {
                return (
                    <ObserveState
                        listenTo={dataDefinition}
                        properties={["fields"]}
                        control={() => {
                            return (
                                <VariablePickerDialog
                                    selected={rule.name}
                                    data={dataDefinition}
                                    onVariableSet={(path: string, def?: IDataDefinition) => {
                                        if (def) {
                                            dataDefinition.fields.push(def);
                                            props.onSet(rule, def.name);
                                            StateManager.propertyChanged(dataDefinition, "fields");
                                        } else {
                                            rule.name = path;
                                            props.onSet(rule, path);
                                        }
                                        StateManager.propertyChanged(rule, "name");
                                        onCloseDialog();
                                    }}
                                    allowNewVariable={allowNew}
                                    show={editContext.selectedColumnHeader === rule}
                                    onClose={onCloseDialog}
                                />
                            );
                        }}
                    />
                );
            }}
        />
    );
};
